import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import del from "../../src/assets/images/del1.png";
import {
  PostCallWithErrorResponse,
  simpleGetCallWithErrorResponse,
} from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../component/button";
import Button from 'react-bootstrap/Button';
import CustomSelect from "../constant/customselect";
import { toastMsg } from "../component/toast";
import { updateFormField } from "./Slices/formSlice";
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import Modal from 'react-bootstrap/Modal';
import { Form, FormGroup, FormLabel, FormControl, Row, Col, Spinner } from "react-bootstrap"

export default function JobAnalysis() {
  const navigate = useNavigate();

  const dispatch = useDispatch()
  const formDataRedux = useSelector((state) => state.form);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isLoading, setIsLoading] = useState(false)
  const [feedbackText, setFeedbacktext] = useState('')
  const [isSubmit, setIsSubmit] = useState(false)
  const [formData, setFormData] = useState({
    quizName: '',
    quizDuration: '',
  })
  const handleChangeForQuizDetails = (key, val) => {


    setFormData(prev => ({
      ...prev,
      [key]: val
    }))

  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const [questions, setQuestions] = useState([]);
  const [acceptedQuestions, setAcceptedQuestions] = useState({});
  const [regenerating, setRegenerating] = useState(-1);
  const [isRegenerete, setISRegenerate] = useState(false);
  const [isReplace, setIsReplace] = useState(false);
  const [isMostLike, setIsMostLike] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(-1);

  const state = useSelector((state) => state?.form);

  const handleAccept = (id) => {
    setAcceptedQuestions((prev) => ({ ...prev, [id]: true }));
  };

  const getQuestions = (topic, index, question = '', mostLike = false) => {

    let payload = {
      job_description: state?.finalSelectedJobDescription,
      topics: state.subTopics,
      // subTopics: state.subTopics,
      num_questions: mostLike ? 2 : topic?.length ? 1 : state?.num_questions,
      difficulty_level: state?.difficulty_level,
    }


    let api = index >= 0 ? ApiConfig.REPLACE_QUEST : ApiConfig.GET_QUIZ_QUES


    if (index >= 0) {
      if (mostLike) {
        setIsMostLike(true);
      } else {
        setIsReplace(true);
      }
      payload.question = question
    } else {
      setIsLoading(true);
    }



    PostCallWithErrorResponse(api, payload).then((res) => {
      if (res?.json?.quiz?.quiz_questions || res?.json?.replaced_questions) {
        if (index >= 0) {
          let qust = questions;

          if (mostLike) {
            qust?.splice(index, 0, ...res?.json?.replaced_questions);
          } else {
            qust[index].q = res.json.replaced_questions[0].q;
            qust[index] = res?.json?.replaced_questions[0];
          }

          setQuestions(qust);
        } else {
          setQuestions(res?.json?.quiz?.quiz_questions);
        }
      }
      setIsMostLike(false);
      setIsReplace(false);
      setCurrentIndex(-1);
      handleCancel();
      setIsLoading(false);
    });
  };

  useEffect(() => getQuestions(), []);

  const JOB_DESCRIPTION_STORAGE_KEY = "prev_job_description";
  const DIFFICULTY_STORAGE_KEY = "prev_difficulty_level";
  const NUM_OF_Q_STORAGE_KEY = "prev_num_of_q";
  const TOPICS_STORAGE_KEY = "prev_topics";
  const parseJSONSafe = (value) => {
    try {
      if (value === null || value === "undefined") return undefined;
      return JSON.parse(value);
    } catch {
      return undefined;
    }
  };

  const useGetQuizTrigger = () => {
    useEffect(() => {
      const prevJobDescription =
        parseJSONSafe(sessionStorage.getItem(JOB_DESCRIPTION_STORAGE_KEY)) ||
        "";
      const prevDifficulty =
        parseJSONSafe(sessionStorage.getItem(DIFFICULTY_STORAGE_KEY)) || "";
      const prevNumQuestions =
        parseJSONSafe(sessionStorage.getItem(NUM_OF_Q_STORAGE_KEY)) || "";
      const prevTopics =
        parseJSONSafe(sessionStorage.getItem(TOPICS_STORAGE_KEY)) || [];

      const hasChangedJD =
        prevJobDescription !== formDataRedux.finalSelectedJobDescription;
      const hasChangedDifficulty =
        prevDifficulty !== formDataRedux.difficulty_level;
      const hasChangedNumQ =
        Number(prevNumQuestions) !== Number(formDataRedux.num_questions);
      const hasChangedTopics =
        JSON.stringify(prevTopics) !== JSON.stringify(formDataRedux.subTopics); // arrays

      if (
        hasChangedJD ||
        hasChangedDifficulty ||
        hasChangedNumQ ||
        hasChangedTopics
      ) {
        getQuestions();
        sessionStorage.setItem(
          JOB_DESCRIPTION_STORAGE_KEY,
          JSON.stringify(formDataRedux.finalSelectedJobDescription)
        );
        sessionStorage.setItem(
          DIFFICULTY_STORAGE_KEY,
          JSON.stringify(formDataRedux.difficulty_level)
        );
        sessionStorage.setItem(
          NUM_OF_Q_STORAGE_KEY,
          JSON.stringify(formDataRedux.num_questions)
        );
        sessionStorage.setItem(
          TOPICS_STORAGE_KEY,
          JSON.stringify(formDataRedux.subTopics)
        );
      }
    }, [
      formDataRedux?.finalSelectedJobDescription,
      formDataRedux?.difficulty_level,
      formDataRedux?.num_questions,
      formDataRedux?.subTopics,
    ]);
  };

  // useGetQuizTrigger()
  console.log("formDataRedux-->", formDataRedux);
  const handleRegenerateQust = (option, index) => {

    if (!feedbackText?.trim()) {
      toastMsg('error', 'Please Enter Prompt')
      return
    }

    setISRegenerate(true);

    PostCallWithErrorResponse(ApiConfig.REGENERATE_QUIS, {
      question_json: {
        q: option.q,
        options: option.options,
        correct_answer: option.correct_answer,
        topics: option.topics,
        rationale: option.rationale,

      },
      feedback_text: feedbackText,
      num_questions: 1,
      difficulty_level: state?.difficulty_level,
      topics: option.topics
    }).then((res) => {
      if (res?.json?.quiz) {
        let qust = questions;
        res.json.quiz[0].q = res.json.quiz[0].question;
        qust[index] = res?.json?.quiz[0];

        setQuestions(qust);
      }

      setISRegenerate(false);

      handleCancel();
    });
  };

  const handleDecline = (id) => {
    let quis = questions?.filter((_, index) => index != id);

    setQuestions(quis);
  };

  const handleRegenerate = (id) => {
    setRegenerating(id);
  };

  const handleCancel = () => {
    setRegenerating(-1);
  };

  const handleAddQuestion = () => {
    const newId = questions.length + 1;
    const newQuestion = {
      id: newId,
      text: `Sample question ${newId} goes here.`,
      options: ["A) Option 1", "B) Option 2", "C) Option 3", "D) Option 4"],
      correctAnswer: "A) Option 1",
      rationale: "Sample rationale for this new question.",
    };
    setQuestions((prev) => [...prev, newQuestion]);
  };

  const handleSubmit = async () => {

    if (!formData.quizDuration || !formData.quizName) {
      toastMsg("error", "Please Enter Quiz Name And Quiz Duration");
      return;
    }

    setIsSubmit(true);

    PostCallWithErrorResponse(ApiConfig.SAVE_QUIZ_QUST, {
      jobInfoId: state?.jobDescriptionId,
      quizName: formData.quizName,
      jobcode: state?.tempJobCode,
      difficultyLevel: state?.difficulty_level,
      duration: formData?.quizDuration,
      questions: questions,
    }).then((res) => {
      if (res?.json?.succeded) {
        toastMsg("success", res?.json?.response?.statusMessage);

        dispatch(updateFormField({ field: 'subTopics', value: [] }))
        dispatch(updateFormField({ field: 'tTopics', value: [] }))
        dispatch(updateFormField({ field: 'topics', value: [] }))
        dispatch(updateFormField({ field: 'allSubTopics', value: [] }))
        dispatch(updateFormField({
          field: 'customTopics', value: {
            topics: [],
            subTopics: [],
            previousSubTopics: []
          }
        }))
        setFormData({
          quizDuration: "",
          quizName: "",
        });

        if (state?.isAddQuizFromAddCode) {
          navigate(`/addEditGroup/${state?.tempJobCode}?detailsId=${state?.jdId}`)

          dispatch(updateFormField({ field: 'isAddQuizFromAddCode', value: false }))

          dispatch(updateFormField({ field: 'jdId', value: "" }))


          return
        }
        if (state?.isSkippedQuiz) {
          dispatch(updateFormField({ field: 'isSkippedQuiz', value: false }))
          navigate('/')
        } else {
          dispatch(
            updateFormField({
              field: "step",
              value: 3,
            })
          );
          navigate("/jobDescription")
        }

      } else {
        toastMsg("error", res?.json?.response?.statusMessage);
      }

      setIsSubmit(false)

    }).finally(() => {
      handleClose()
    })

  }

  const removeQuestion = (index) => {

    if (questions.length === 1) {

      toastMsg('error', 'One Question Is Required')
      return
    }

    let ques = [...questions]

    ques.splice(index, 1)

    setQuestions(ques)

  }


  const words = ['A', "B", "C", "D"]

  const duration = [
    {
      label: '15 minutes',
      value: '15'
    },
    {
      label: '20 minutes',
      value: '20'
    },
    {
      label: '25 minutes',
      value: '25'
    },
    {
      label: '30 minutes',
      value: '30'
    },
    {
      label: '45 minutes',
      value: '45'
    },
    {
      label: '1 hours',
      value: '60'
    },
    {
      label: '15 minutes',
      value: '15'
    },

  ]



  return (
    <div
      style={{ backgroundColor: "#F2F4F7" }}
      className={`canLisContentWrap `}
    >


      <div className="t-wrapper-div p-4">
        {/* <h3 className="ja-1">Step 6: Review and Provide Feedback</h3> */}
        <h5 className="ja-1 mt-2">Review Questions</h5>
        <p className="ja-2 mt-2">
          Select 'Accept' for questions you want to include in the final
          assessment.
        </p>
        {
          isLoading ? <>
            <div className="w-100 text-center">
              <p className='ja-2'> Quiz question are generated using AI and we have another agent reviewing quality of generated questions. Some time generation fall short on number of questions we need , in such cases we again send request to get those remaining questions generated and also reviewed , all this is happening in Backend , so kindly give it some time to process and get back to us with what we needed . Thank you for your Patience !<Spinner animation="grow" size='sm' /> </p>
            </div>

            <div className="w-100 text-center">
              <ShimmerSimpleGallery card imageHeight={300} row={Number(formDataRedux.num_questions)} col={1} />
            </div>
          </>

            :
            <div className="hello">
              {questions.map((q, index) => (
                <div
                  key={q.id}
                  className="skills-box"
                  style={{ marginTop: '10px' }}
                >
                  {/* <h5 className="ja-1 mt-4">Question {index + 1}</h5> */}
                  {acceptedQuestions[q.id] && (
                    <p className="ja-2 ja-4">✓ This question has been accepted</p>
                  )}
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="ja-2 mt-2" style={{ fontSize: '14px', fontWeight: '400' }}>
                      {/* <strong>Question Text:</strong> */} {q.q}
                    </p>
                    <img src={del} style={{ cursor: 'pointer', height: '35px', width: '35px' }} alt="delete"
                      data-toggle="tooltip" data-placement="bottom" title="Delete Question"
                      onClick={() => removeQuestion(index)}
                    />
                  </div>
                  {/* <p className="ja-2">
                    <strong>Options:</strong>
                  </p> */}

                  <ul className="ja-2" style={{ marginBottom: '5px', marginTop: "-10px" }}>
                    {q.options.map((opt, index) => (
                      <li key={index}>{index + 1} : {opt} {q.correct_answer === opt ? " *" : ""}</li>
                    ))}
                  </ul>
                  <p className="ja-2 " style={{ marginBottom: '5px' }}>
                    <strong className="mainTitleColr" style={{ fontWeight: '500' }}>Correct Answer:</strong> {q.correct_answer}
                  </p>
                  <p className="ja-2">
                    <strong className="mainTitleColr" style={{ fontWeight: '500' }}>Rationale:</strong> {q.rationale}
                  </p>

                  {regenerating == -1 && (
                    <div
                      className="button-group"
                      style={{
                        display: "flex",
                        gap: "13px",
                        justifyContent: "end",
                      }}
                    >
                      {/* <button
                        className="btnVldt"
                        style={{ fontSize: "13px" }}
                        onClick={() => handleAccept(q.id)}
                      >
                        Accept
                      </button> */}
                      <CustomButton
                        isDisabled={isReplace || isMostLike}
                        title={"More Like this"}
                        handleClick={() => {
                          setCurrentIndex(index);
                          getQuestions(q?.topics, index, q.q, true);
                        }}
                        buttonType="secondary"
                        isLoading={currentIndex == index && isMostLike}
                      />
                      <CustomButton
                        isDisabled={isReplace || isMostLike}
                        title={"Replace"}
                        handleClick={() => {
                          setCurrentIndex(index);
                          getQuestions(q?.topics, index, q.q);
                        }}
                        isLoading={currentIndex == index && isReplace}
                        buttonType="secondary"
                      />
                      <CustomButton
                        isDisabled={index && (isReplace || isMostLike)}
                        title={"Regenerate"}
                        handleClick={() => {
                          handleRegenerate(index);
                        }}
                        buttonType="secondary"
                      />
                    </div>
                  )}

                  {regenerating == index && (
                    <>
                      <div className="gen">
                        <label className="jb-4 mt-3">
                          Provide specific feedback for regeneration:
                        </label>
                        <textarea
                          name="companyDescription"
                          rows={4}
                          value={feedbackText}
                          onChange={(e) => setFeedbacktext(e.target.value)}
                          className="w-full p-2 rounded-md bg-green-500 border border-grey text-black placeholder-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 jb-in-1 mt-2"
                        />
                      </div>
                      <div
                        className="button-group"
                        style={{ display: "flex", gap: "10px" }}
                      >
                        <CustomButton
                          handleClick={() => handleRegenerateQust(q, index)}
                          title={"Submit for Regeneration"}
                          isLoading={isRegenerete}
                        />
                        <CustomButton

                          buttonType='secondary'
                          title="Cancel"
                          handleClick={() => handleCancel(index)}
                        />
                      </div>
                    </>
                  )}
                </div>
              ))}

              {/* <form className="space-y-5 max-w-2xl job-description-form mt-2 d-flex flex-row w-100 gap-2">
                <div>
                  <label className="jb-4-- form-label job_size col-md-12">
                    Quiz Name
                  </label>
                  <input

                    name="quizName"
                    value={formData.quizName}
                    onChange={handleChange}
                    className="w-full p-2 rounded-md bg-gray-100 border border-grey text-black jb-in-1 "
                  />
                </div>

                <div className="">
                  <label className="jb-4-- form-label job_size col-md-12">
                    Quiz Duration
                  </label>
                  <input

                    name="quizDuration"
                    value={formData.quizDuration}
                    onChange={handleChange}
                    className="w-full p-2 rounded-md bg-gray-100 border border-grey text-black jb-in-1 "
                  />
                </div>
              </form> */}

              {/* <div className="mt-3">
            <button
              className="btnVldt"
              style={{ fontSize: "13px" }}
              onClick={handleAddQuestion}
            >
              Add one more Question
            </button>
          </div> */}


            </div>
        }
        <div className="question-modal-footer mt-2">
          {/* <CustomButton
                title={'Back To JD'}
                handleClick={() => {
                  dispatch(updateFormField({ field: 'step', value: 5 }))
                  dispatch(updateFormField({
                    'field': 'customTopics', value: {
                      topics: [],
                      subTopics: []
                    }
                  }))

                  dispatch(updateFormField({ field: 'topics', value: [] }))

                  dispatch(updateFormField({ field: 'topics', value: [] }))

                  dispatch(updateFormField({ field: 'subTopics', value: [] }))

                  dispatch(updateFormField({ field: 'difficulty_level', value: "" }))

                  dispatch(updateFormField({ field: 'num_questions', value: 3 }))
                  navigate("/jobDescription")

                }}
                isLoadin
                g={false}
              /> */}
          <CustomButton
            title="Back"
            handleClick={() => navigate('/assessmentGenerator')}
            buttonType='secondary'
          />
          <CustomButton
            title={'Submit'}
            // handleClick={handleSubmit}
            handleClick={handleShow}
          // isLoading={isSubmit}
          />
        </div>

      </div>
      <>


        <Modal centered show={show} onHide={handleClose}>
          <Modal.Header closeButton className="custom-close-btn">
            <h6 className="mb-0 mt-1">Quiz Details</h6>
          </Modal.Header>
          <Modal.Body>
            <Form noValidate onSubmit={handleSubmit}>
              <Form.Group controlId="designation" className="mb-3">
                <Row className="align-items-center">
                  <Col sm={3}>
                    <Form.Label className="job_size">Quiz Name</Form.Label>
                  </Col>
                  <Col sm={9}>
                    {/* <Form.Label className="job_size">Company Name</Form.Label> */}
                    <Form.Control
                      type="text"
                      className="input-text-14"
                      required
                      placeholder="Quiz Name"
                      value={formData?.quizName}
                      onChange={(e) => handleChangeForQuizDetails('quizName', e.target.value)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please Enter Quiz Name!
                    </Form.Control.Feedback>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group controlId="designation" className="mb-3">
                <Row className="align-items-center">
                  <Col sm={3}>
                    <Form.Label className="job_size">Quiz Duration</Form.Label>
                  </Col>
                  <Col sm={9}>

                    <Form.Select aria-label="Default select example"
                      name='quizDuration'
                      value={formData?.quizDuration}
                      onChange={(e) => handleChangeForQuizDetails('quizDuration', e.target.value)}
                      className="selectPlaceholder"
                      placeholder="Select Quiz Duration"

                    >
                      <option value={""} disabled>Select Quiz Duration</option>
                      {
                        duration?.map((type, index) => {
                          return <option value={type?.value} key={index}
                            className="job_size"
                            style={{ fontSize: "14px", color: "red" }}
                          >{type?.label}</option>
                        })
                      }

                    </Form.Select>

                    <Form.Control.Feedback type="invalid">
                      Please Select Quiz Duration!
                    </Form.Control.Feedback>
                  </Col>
                </Row>
              </Form.Group>
            </Form>

          </Modal.Body>
          <Modal.Footer>

            <CustomButton
              title={'Close'}
              handleClick={handleClose}
              buttonType='secondary'

            />

            <CustomButton
              title={'Save'}
              handleClick={handleSubmit}

              isLoading={isSubmit}
            />
          </Modal.Footer>
        </Modal>
      </>
    </div>
  );
}
